import { Validators } from '@angular/forms';
import { PolluxFormConfig } from '../../../../../components/common/pollux-form-config/pollux-form-config';
import { PolluxValidators } from '../../../../../components/common/pollux-validators/pollux-validators';

export const valuationsFormConfig: PolluxFormConfig[] = [
  {
    name: 'oid',
    value: 'oid',
    disabled: true
  },
  {
    name: 'TotalArea',
    value: 'TotalArea'
  },
  {
    name: 'GrossValue',
    value: 'GrossValue'
  },
  {
    name: 'NetValue',
    value: 'NetValue'
  },
  {
    name: 'SayValue',
    value: 'SayValue'
  },
  {
    name: 'InitialYield',
    value: 'InitialYield'
  },
  {
    name: 'ReversionaryYield',
    value: 'ReversionaryYield'
  },
  {
    name: 'NetRent',
    value: 'NetRent'
  },
  {
    name: 'PercentEquity',
    value: 'PercentEquity'
  },
  {
    name: 'PropertyIrr',
    value: 'PropertyIrr'
  },
  {
    name: 'CapitalCosts',
    value: 'CapitalCosts'
  },
  {
    name: 'AcquisitionCosts',
    value: 'AcquisitionCosts'
  },
  {
    name: 'EquivalentYield',
    value: 'EquivalentYield'
  },
  {
    name: 'TrueEquivalentYield',
    value: 'TrueEquivalentYield'
  },
  {
    name: 'GrossRent',
    value: 'GrossRent'
  },
  {
    name: 'GrossRentalValue',
    value: 'GrossRentalValue'
  },
  {
    name: 'NoOfTenants',
    value: 'NoOfTenants',
    validators: [Validators.min(0), PolluxValidators.integer(true)]
  },
  {
    name: 'numberOfInternalParkingPlaces',
    value: 'numberOfInternalParkingPlaces',
    validators: [Validators.min(0), PolluxValidators.integer(true)]
  },
  {
    name: 'numberOfExternalParkingPlaces',
    value: 'numberOfExternalParkingPlaces',
    validators: [Validators.min(0), PolluxValidators.integer(true)]
  },
  {
    name: 'nursingHomeTotal',
    value: 'nursingHomeTotal',
    validators: [Validators.min(0), PolluxValidators.integer(true)]
  },
  {
    name: 'nursingHomeSingleRooms',
    value: 'nursingHomeSingleRooms',
    validators: [Validators.min(0), PolluxValidators.integer(true)]
  },
  {
    name: 'totalNumberOfParkingPlaces',
    value: 'totalNumberOfParkingPlaces',
    validators: [Validators.min(0), PolluxValidators.integer(true)]
  },
  {
    name: 'residentialUnits',
    value: 'residentialUnits',
    validators: [Validators.min(0), PolluxValidators.integer(true)]
  },
  {
    name: 'nursingHomeDoubleRooms',
    value: 'nursingHomeDoubleRooms',
    validators: [Validators.min(0), PolluxValidators.integer(true)]
  },
  {
    name: 'hotelNumberOfRooms',
    value: 'hotelNumberOfRooms',
    validators: [Validators.min(0), PolluxValidators.integer(true)]
  },

  {
    name: 'Region',
    value: 'Region'
  },
  {
    name: 'Sector',
    value: 'Sector'
  },
  {
    name: 'EntityId',
    value: 'EntityId'
  },
  {
    name: 'PreparerName',
    value: 'PreparerName'
  },
  {
    name: 'PrimaryUse',
    value: 'PrimaryUse'
  },
  {
    name: 'PropFileRefNo',
    value: 'PropFileRefNo'
  },
  {
    name: 'CurrencyCode',
    value: 'CurrencyCode'
  },
  {
    name: 'CurrencyDescription',
    value: 'CurrencyDescription'
  },
  {
    name: 'CurrencyDescription',
    value: 'CurrencyDescription',
    disabled: true,
    validators: [Validators.maxLength(100)]
  },
  {
    name: 'propertyName',
    value: 'propertyName',
    disabled: true
  },
  {
    name: 'propertyPrimaryUse',
    value: 'primaryUse',
    disabled: true
  },
  {
    name: 'street',
    value: 'street',
    disabled: true
  },
  {
    name: 'numberFrom',
    value: 'numberFrom',
    disabled: true
  },
  {
    name: 'numberTo',
    value: 'numberTo',
    disabled: true
  },
  {
    name: 'numberAdd',
    value: 'numberAdd',
    disabled: true
  },
  {
    name: 'PostCode',
    value: 'PostCode',
    disabled: true
  },
  {
    name: 'city',
    value: 'city',
    disabled: true
  },
  {
    name: 'propertyRegion',
    value: 'Region',
    disabled: true
  },
  {
    name: 'SubMarket',
    value: 'SubMarket',
    disabled: true
  },
  {
    name: 'Country',
    value: 'Country',
    disabled: true
  },
  {
    name: 'constructionYear',
    value: 'constructionYear',
    disabled: true
  },
  {
    name: 'renovationYear',
    value: 'renovationYear',
    disabled: true
  },
  {
    name: 'unitOfLengthId',
    value: 'unitOfLengthId'
  },
  {
    name: 'currencyId',
    value: 'currencyId'
  },
  {
    name: 'filledOnSave',
    fixedValue: 'Filled on save',
    disabled: true
  },
  {
    name: 'filledWithProperty',
    fixedValue: 'Filled with Property...',
    disabled: true
  },  
  {
    name: 'createdBy',
    value: 'createdBy',
    disabled: true
  },
  {
    name: 'modifiedBy',
    value: 'modifiedBy',
    disabled: true
  },
  {
    name: 'createdAt',
    value: 'createdAt',
    isDate: true,
    disabled: true
  },
  {
    name: 'modifiedAt',
    value: 'modifiedAt',
    isDate: true,
    disabled: true
  },
  {
    name: 'OwnerBuId',
    value: 'OwnerBuId',
    disabled: true
  },
  {
    name: 'projectPuid',
    value: 'projectPuid'
  },
  {
    name: 'valuationId',
    value: 'valuationId'
  },
  {
    name: 'energyLabelDescription',
    value: 'energyLabelDescription',
    disabled: true
  },
  {
    name: 'propertyID',
    value: 'propertyID'
  },
  {
    //required for Project retriever
    name: 'projectPuidDescription',
    value: 'projectPuidDescription',
    disabled: true
  },
  {
    //required for ValuationPortfolio retriever
    name: 'valuationIdDescription',
    value: 'valuationIdDescription',
    disabled: true
  },
  {
    //required for Property retriever
    name: 'propertyIDDescription',
    value: 'propertyIDDescription',
    disabled: true
  }
];
